import { Phone, Mail } from "lucide-react";
import { BUSINESS } from "../data/site";

export const CallCta = ({ heading = "Get Security Coverage Today", sub = "Speak directly with our 24/7 dispatch team — no forms, no waiting.", testid = "cta" }) => (
  <section data-testid={`${testid}-section`} className="bg-[#14161C] border-y border-[#FF9100]/20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
      <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-3">{heading}</h2>
      <p className="text-gray-400 mb-8 max-w-2xl mx-auto">{sub}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a
          href={BUSINESS.phoneHref}
          data-testid={`${testid}-call-btn`}
          className="inline-flex items-center gap-2 bg-[#FF9100] hover:bg-[#FF5500] text-[#0D0E11] font-bold px-8 py-4 rounded-full transition-all duration-200 hover:scale-105 active:scale-95"
        >
          <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
        </a>
        <a
          href={BUSINESS.emailHref}
          data-testid={`${testid}-email-btn`}
          className="inline-flex items-center gap-2 border border-[#FF9100]/50 hover:border-[#FF9100] hover:bg-[#FF9100]/10 text-[#FF9100] font-semibold px-8 py-4 rounded-full transition-all duration-200 hover:scale-105 active:scale-95"
        >
          <Mail className="w-5 h-5" /> {BUSINESS.email}
        </a>
      </div>
    </div>
  </section>
);
